import React, { useContext, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'

import { StyledSource, StyledVideo } from './Video.styled'
import LayoutContext from '../../contexts/LayoutContext'

const Video = (props) => {
  const {
    autoPlay,
    className,
    canPaused,
    url,
    withControls = true,
    poster,
  } = props
  const { pauseVideo, setPauseVideo } = useContext(LayoutContext)
  const vidRef = useRef()

  useEffect(() => {
    if (!withControls) vidRef.current.play()
  }, [!withControls])

  useEffect(() => {
    if (pauseVideo && canPaused) vidRef.current.pause()
    setPauseVideo(false)
  }, [pauseVideo])

  if (withControls) {
    return (
      <StyledVideo
        autoPlay={autoPlay}
        className={className}
        ref={vidRef}
        poster={poster}
        controls
        playsInline
        preload="auto"
      >
        <StyledSource src={url} type="video/mp4" />
      </StyledVideo>
    )
  } else {
    return (
      <StyledVideo
        className={className}
        loop
        ref={vidRef}
        poster={poster}
        muted
        autoPlay
        playsInline
        preload="auto"
      >
        <StyledSource src={url} type="video/mp4" />
      </StyledVideo>
    )
  }
}

Video.propTypes = {
  url: PropTypes.string.isRequired,
}

export default Video
